import { render } from "./ProposalBuyerSearch.vue?vue&type=template&id=660be0a4&scoped=true"
import script from "./ProposalBuyerSearch.vue?vue&type=script&lang=ts"
export * from "./ProposalBuyerSearch.vue?vue&type=script&lang=ts"

import "./ProposalBuyerSearch.vue?vue&type=style&index=0&id=660be0a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-660be0a4"

export default script